import { useStyletron } from '@thanx/uikit/theme'
import useCurrentMerchant from 'hooks/useCurrentMerchant'
import { buildTranslate } from 'locales'
import React from 'react'
import { Container } from 'react-bootstrap-five'
import LookerFooter from 'scenes/LookerEmbed/components/LookerFooter'
import LookerIframe from 'scenes/LookerEmbed/LookerIframe'

type Props = {
  path: string
  height?: number
  translationKey: string
}

const LookerEmbedTab: React.FC<Props> = ({
  path,
  height = 1450,
  translationKey,
}) => {
  const merchant = useCurrentMerchant()
  const [css] = useStyletron()
  const t = buildTranslate(translationKey)

  if (!merchant) return null

  return (
    <Container className={`px-0 ${css({ minHeight: `${height + 300}px` })}`}>
      <LookerIframe
        path={path}
        merchant={merchant}
        height={`${height}px`}
        title={t('title')}
      />
      <LookerFooter className="my-xl" />
    </Container>
  )
}

export default LookerEmbedTab
